import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { Dealer } from '../../types';

interface DealerState {
  selectedDealer: Dealer | null;
}

const initialState: DealerState = {
  selectedDealer: null,
};

export const dealerSlice = createSlice({
  name: 'dealer',
  initialState,
  reducers: {
    setSelectedDealer: (state: DealerState, action: PayloadAction<Dealer | null>) => {
      state.selectedDealer = action.payload;
    },
    clearSelectedDealer: state => {
      state.selectedDealer = null;
    },
  },
});

export const { setSelectedDealer, clearSelectedDealer } = dealerSlice.actions;

// Selectors
export const selectSelectedDealer = (state: RootState) => state.dealer.selectedDealer;

export default dealerSlice.reducer;
